import PortalOverride from "@Components/admin/portal-override";
import { BottomMenuItem } from "@Components/game";
import { Actions, AppContext, Events, UnityBridge } from "@Context/common/general/context";
import GridImage from "@Resources/game/UIGridBackground.png";
import { faDoorOpen, faPeopleArrows, faSignOutAlt, faTimes, faUserCog, faUsersCog } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import useI18n from "@i18n";
import { Box, Dialog, DialogActions, DialogContent, Grid, Typography, Stack, IconButton } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const ExitDialog = ({ open, onClose }) => {
  const { i18n } = useI18n();
  const theme = useTheme();
  const history = useNavigate();
  const { state, dispatch } = React.useContext(AppContext);

  const isMobile = state.device.isMobile;
  const isUnityEmbedded = state.device.isUnityEmbedded;
  const [isSuperAdmin] = useState(state.user.isSuperAdmin);

  const onAccountClicked = () => {
    Events.app.navigate.emit({ path: "/select-account" });
    onClose();
  };

  const onAdminClicked = () => {
    history("/settings/admin");
    onClose();
  };

  const onLogoutClicked = () => {
    dispatch({
      type: Actions.FirebaseActions.Logout,
    });
    onClose();
  };

  const onExitClicked = () => {
    UnityBridge.dispatchWebEvent({
      type: UnityBridge.OutgoingWebEvents.ExitApplicationSignal,
    });
  };

  const onSwitchClicked = () => {
    onClose();
    Events.app.navigate.emit({ path: "/select-profile" });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <IconButton icon={faTimes} onClick={onClose} />

      {isMobile ? (
        <Typography variant="h4" color="secondary">
          {i18n("settings.heading")}
        </Typography>
      ) : null}
      <DialogContent>
        <Grid container spacing={2} alignItems={"flex-start"} justifyContent={"center"}>
          {/* Switch User */}
          {state.user.teams.length > 0 &&
            BottomMenuItem({
              size: isUnityEmbedded ? 6 : 6,
              title: i18n("header.exit.switch-profile.title"),
              image: null,
              icon: faPeopleArrows,
              locked: false,
              handler: onSwitchClicked,
            })}

          {/* Account */}
          {!isUnityEmbedded
            ? BottomMenuItem({
                size: isUnityEmbedded ? 6 : 6,
                title: i18n("header.exit.account.title"),
                toolTip: "Manage your account",
                image: null,
                icon: faUserCog,
                locked: false,
                handler: onAccountClicked,
              })
            : null}

          {/* Log out */}
          {BottomMenuItem({
            size: isSuperAdmin ? 6 : 12,
            title: i18n("header.exit.logout.title"),
            image: null,
            icon: faSignOutAlt,
            locked: false,
            handler: onLogoutClicked,
          })}

          {/* Admin */}
          {isSuperAdmin
            ? BottomMenuItem({
                size: isUnityEmbedded ? 6 : 6,
                title: i18n("header.exit.admin.title"),
                image: null,
                icon: faUsersCog,
                locked: false,
                handler: onAdminClicked,
              })
            : null}

          {/* Exit App */}
          {isUnityEmbedded
            ? BottomMenuItem({
                size: isSuperAdmin ? 6 : 12,
                title: i18n("header.exit.exit.title"),
                image: null,
                icon: faDoorOpen,
                locked: false,
                handler: onExitClicked,
              })
            : null}

          {isSuperAdmin ? (
            <Grid
              item
              xs={"12"}
              sm={"12"}
              md={"12"}
              lg={"12"}
              style={{
                marginTop: theme.spacing(1),
                maxHeight: "300px",
                overflowX: "hidden",
                overflowY: "scroll",
              }}
            >
              <PortalOverride />
            </Grid>
          ) : null}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ExitDialog;
